import * as CryptoJS from 'crypto-js';

const SECRET_KEY_HEX = process.env.REACT_APP_CRYPTO_SECRET || '';
const SECRET_KEY = CryptoJS.enc.Hex.parse(SECRET_KEY_HEX); // ✅ converte HEX → bytes

// Chave secreta para criptografia/descriptografia.
// EM UM AMBIENTE REAL, ESTA CHAVE DEVE SER OBTIDA DE FORMA SEGURA (ex: Variável de Ambiente, KMS)
// E NUNCA HARDCODED NO FRONTEND. Para fins de demonstração, usaremos uma chave simples.
// const SECRET_KEY = 'sua-chave-secreta-muito-forte-aqui';

/**
 * Criptografa uma string usando AES.
 * @param text A string a ser criptografada (o CPF).
 * @returns A string criptografada em formato Base64.
 */
export const encrypt = (text: string): string => {
  if (!text) return '';

  const encrypted = CryptoJS.AES.encrypt(text, SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(); // base64 normal

  // converte para base64url
  return encrypted
    .replace(/\+/g, '-')
    .replace(/\//g, '_')

    .replace(/=+$/, '');
};

/**
 * Descriptografa uma string usando AES.
 * @param encryptedText A string criptografada.
 * @returns A string descriptografada.
 */
export const decrypt = (encryptedText: string): string => {
  if (!encryptedText) return '';
  try {

    const decrypted = CryptoJS.AES.decrypt(encryptedText, SECRET_KEY, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Erro ao descriptografar:', error);
    return '';
  }
};
